module.exports = __webpack_public_path__ + "img/small.ef5029eb.jpg";